import { useCallback, useEffect, useState } from "react";
import {
  MDBModal, MDBModalDialog, MDBModalContent, MDBModalHeader, MDBModalTitle,
  MDBModalBody, MDBModalFooter, MDBBtn, MDBInput
} from "mdb-react-ui-kit";

import { toast } from "Projects/CC_cubi_clan_project/GlobalComponents/ToastHost/ToastHost";
import { createGame, getCatalogRegiones, isOk } from "Projects/CHAMP_championsjourney_project/Utils/ChampService";

export default function CreateGameModal({ show, setShow, onCreated }) {
  const [nombre, setNombre] = useState("");
  const [regionInicio, setRegionInicio] = useState("");
  const [nombrePersonaje, setNombrePersonaje] = useState("");
  const [saving, setSaving] = useState(false);
  const [regiones, setRegiones] = useState([]);

  useEffect(() => {
    getCatalogRegiones().then((res) => {
      if (isOk(res) && Array.isArray(res.DATA)) {
        setRegiones(res.DATA);
        if (res.DATA.length > 0) setRegionInicio(res.DATA[0].nombre);
      }
    });
  }, []);

  useEffect(() => {
    if (show) {
      setNombre("");
      setNombrePersonaje("");
      if (regiones.length > 0) setRegionInicio(regiones[0].nombre);
    }
  }, [show, regiones]);

  const handleClose = useCallback(() => setShow(false), [setShow]);

  async function handleSave() {
    if (!nombre.trim()) {
      toast.show({ message: "El nombre de la partida es obligatorio", type: "warning" });
      return;
    }
    setSaving(true);
    try {
      const res = await createGame({
        nombre: nombre.trim(),
        regionInicio,
        nombrePersonaje: nombrePersonaje.trim() || null,
      });
      if (isOk(res)) {
        toast.show({ message: "Partida creada", type: "success" });
        setShow(false);
        onCreated && onCreated(res.DATA);
      } else {
        toast.show({ message: res?.MESSAGE || "No se pudo crear la partida", type: "danger" });
      }
    } finally {
      setSaving(false);
    }
  }

  return (
    <MDBModal show={show} onHide={handleClose} tabIndex="-1">
      <MDBModalDialog>
        <MDBModalContent>
          <MDBModalHeader>
            <MDBModalTitle>Nueva partida</MDBModalTitle>
            <MDBBtn className="btn-close" color="none" onClick={handleClose} />
          </MDBModalHeader>
          <MDBModalBody>
            <MDBInput
              label="Nombre de la partida"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              className="mb-3"
            />
            <label className="form-label">Región de inicio</label>
            <select
              className="form-select mb-3"
              value={regionInicio}
              onChange={(e) => setRegionInicio(e.target.value)}
            >
              {regiones.map((r) => (
                <option key={r.nombre} value={r.nombre}>
                  {r.nombre.charAt(0) + r.nombre.slice(1).toLowerCase()}
                </option>
              ))}
            </select>
            <MDBInput
              label="Nombre de tu personaje (opcional)"
              value={nombrePersonaje}
              onChange={(e) => setNombrePersonaje(e.target.value)}
            />
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn color="secondary" onClick={handleClose} disabled={saving}>Cancelar</MDBBtn>
            <MDBBtn className="champ-btn-primary" onClick={handleSave} disabled={saving}>
              Crear
            </MDBBtn>
          </MDBModalFooter>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  );
}
